<div *ngIf="isLoading">Loading Residential Status List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="residentialStatus" [(ngModel)]="model.residentialStatus" [required]="required">
  <option *ngFor="let singleResidentialStatus of residentialStatuses" [ngValue]="singleResidentialStatus">{{ singleResidentialStatus.name }}</option>
</select>
